import Vue from "vue"
import Vuex from "vuex"
import auth from "./modules/auth"
import garden from "./modules/garden"
import tasks from "./modules/tasks"
import ui from "./modules/ui"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { auth, garden, tasks, ui },
})
